import { useState, useEffect } from 'react';

const scrollTo = (id: string) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#0A0A0A]/97 backdrop-blur-md border-b border-[#C9A84C]/15 shadow-[0_2px_40px_rgba(0,0,0,0.6)]'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 md:px-12 lg:px-16 flex items-center justify-between h-[80px]">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => { e.preventDefault(); scrollTo('#home'); }}
            className="flex items-center gap-3 cursor-pointer group flex-shrink-0"
          >
            <div className="w-[2px] h-10 bg-[#C9A84C] group-hover:h-12 transition-all duration-300"></div>
            <div>
              <div className="font-serif text-white text-[18px] font-bold tracking-[0.1em] uppercase leading-tight">
                Gamble <span className="text-[#C9A84C]">&amp;</span> Garcia
              </div>
              <div className="text-[#C9A84C]/60 text-[9px] tracking-[0.38em] uppercase font-light">
                Attorneys at Law
              </div>
            </div>
          </a>

          {/* Desktop CTAs only — single page, no nav links */}
          <div className="hidden lg:flex items-center gap-4">
            <div className="flex items-center gap-2 mr-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-[#C9A84C] text-xs"></i>
              </div>
              <span className="text-white/45 text-[11px] tracking-wider">4.8 Rating &bull; Martindale-Hubbell Distinguished</span>
            </div>
            <a
              href="tel:8059228308"
              className="flex items-center gap-2 px-5 py-2.5 border border-white/20 text-white/80 text-[11px] font-semibold tracking-[0.18em] uppercase rounded-sm hover:border-[#C9A84C]/60 hover:text-[#C9A84C] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xs"></i>
              (805) 922-8308
            </a>
            <button
              onClick={() => scrollTo('#contact')}
              className="px-6 py-2.5 bg-[#C9A84C] text-black text-[11px] font-bold tracking-[0.2em] uppercase rounded-sm hover:bg-[#b8943e] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Speak With an Attorney
            </button>
          </div>

          {/* Mobile toggle */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="lg:hidden bg-[#0A0A0A]/99 border-t border-[#C9A84C]/15 px-6 py-6 flex flex-col gap-4">
            <div className="flex items-center gap-2 py-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-[#C9A84C] text-xs"></i>
              </div>
              <span className="text-white/45 text-xs tracking-wider">4.8 Rating &bull; Martindale-Hubbell Distinguished</span>
            </div>
            <div className="flex flex-col gap-3 pt-2 border-t border-white/10">
              <button
                onClick={() => { setMenuOpen(false); scrollTo('#contact'); }}
                className="text-center py-3.5 bg-[#C9A84C] text-black text-xs font-bold tracking-[0.2em] uppercase rounded-sm cursor-pointer whitespace-nowrap"
              >
                Speak With an Attorney
              </button>
              <a
                href="tel:8059228308"
                className="text-center py-3.5 border border-white/20 text-white text-xs font-semibold tracking-[0.2em] uppercase rounded-sm cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-phone-fill"></i>(805) 922-8308
              </a>
            </div>
          </div>
        )}
      </header>

      {/* Sticky bottom CTA bar (mobile) */}
      <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden flex border-t border-[#C9A84C]/20">
        <button
          onClick={() => scrollTo('#contact')}
          className="flex-1 py-4 bg-[#141414] text-[#C9A84C] text-[11px] font-bold tracking-[0.18em] uppercase text-center cursor-pointer whitespace-nowrap"
        >
          Free Consultation
        </button>
        <a
          href="tel:8059228308"
          className="flex-1 py-4 bg-[#C9A84C] text-black text-[11px] font-bold tracking-[0.18em] uppercase text-center cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
        >
          <i className="ri-phone-fill text-sm"></i> Call Now
        </a>
      </div>
    </>
  );
}
